import React from 'react';

const FlagsContext = React.createContext({});

export default FlagsContext;
